import { STATUS_STYLE } from "@/constants/options";

export const Logo = ({ className = "h-9" }) => (
  <img src="/brand/nirogyam-logo-wide.png" alt="Nirogyam Diagnostics & Healthcare" className={`${className} w-auto object-contain`} />
);

export const TM = () => <sup className="text-[0.55em] font-semibold align-super ml-[1px]" aria-label="trademark">TM</sup>;
export const IsoCred = () => <span className="whitespace-nowrap">isoCred<TM /></span>;

export const ProductMark = ({ compact = false }) => (
  <div className="flex items-center gap-2.5 shrink-0" data-testid="brand-mark">
    <img src="/brand/nirogyam-mark.png" alt="Nirogyam" className="h-9 w-9 shrink-0 object-contain" />
    {!compact && (
      <div className="leading-tight whitespace-nowrap">
        <div className="font-display font-extrabold text-[17px] text-[#48217A] tracking-tight">isoCred<TM /></div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#2E9B65] font-semibold">by Nirogyam</div>
      </div>
    )}
  </div>
);

export const StatusBadge = ({ status, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${STATUS_STYLE[status] || "bg-slate-50 text-slate-600 border-slate-200"}`}>
    {status || "—"}
  </span>
);

export const PriorityBadge = ({ p }) => (
  <span className={`font-mono text-[10px] font-semibold px-1.5 py-0.5 rounded ${p === "CORE" ? "bg-[#48217A] text-white" : "bg-[#F3EFFA] text-[#48217A]"}`}>{p}</span>
);

export const PageHeader = ({ eyebrow, title, desc, children }) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-6 fade-up">
    <div>
      {eyebrow && <div className="qt-eyebrow mb-1.5">{eyebrow}</div>}
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#172238]">{title}</h1>
      {desc && <p className="text-sm text-[#5A6B87] mt-1.5 max-w-3xl">{desc}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Empty = ({ icon: Icon, title, desc, children }) => (
  <div className="qt-card p-10 text-center" data-testid="empty-state">
    {Icon && <Icon className="mx-auto h-9 w-9 text-[#48217A]/40 mb-3" />}
    <div className="font-display font-semibold text-[#172238]">{title}</div>
    {desc && <p className="text-sm text-[#5A6B87] mt-1 max-w-md mx-auto">{desc}</p>}
    {children && <div className="mt-4 flex justify-center gap-2">{children}</div>}
  </div>
);
